import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=75d0aca6"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&id=75d0aca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports